// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { buildProviderWithDefinition } from "@coveo/headless-react/ssr-commerce";
import React, { ReactNode, useMemo } from "react";
import { connect } from "react-redux";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { hasEngine } from "@NA/Utils/Coveo/CoveoUtils";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        coveoCommerce: state.ADIGlobalData.coveoCommerce,
    };
};

type Props = ReturnType<typeof mapStateToProps> & { children: ReactNode };

const CoveoProvider = ({ coveoCommerce, children }: Props) => {
    if (
        !hasEngine(coveoCommerce) ||
        !coveoCommerce.providerDefinition ||
        Object.keys(coveoCommerce.providerDefinition).length === 0 ||
        !coveoCommerce.staticState ||
        !coveoCommerce.navigatorContext
    )
        return <>{children}</>;

    const Provider = useMemo(() => {
        return buildProviderWithDefinition(coveoCommerce.providerDefinition);
    }, [coveoCommerce.providerDefinition]);

    return (
        <Provider staticState={coveoCommerce.staticState} navigatorContext={coveoCommerce.navigatorContext.marshal}>
            {children}
        </Provider>
    );
};

export default connect(mapStateToProps)(CoveoProvider);
